/** Example shapes for editors — use “Insert sample” or as placeholders. */

export const CMS_PLACEHOLDER_BODY_JSON = `{
  "schemaVersion": 1,
  "sections": [
    {
      "key": "hero_main",
      "type": "hero",
      "enabled": true,
      "props": {
        "heading": "All-in-One Hiring Suite",
        "subheading": "Streamline hiring end to end.",
        "primaryCta": { "label": "Book Demo", "href": "/contact-us" },
        "heroImage": {
          "fileKey": "public/pages/your-page-slug/hero-v1-20260519T103000Z.webp",
          "alt": "Product screenshot"
        }
      }
    }
  ]
}`;

export const CMS_PLACEHOLDER_SEO_JSON = `{
  "title": "Your Page Title | Skillbrew.AI",
  "description": "Short description for search results.",
  "keywords": ["keyword1", "keyword2"],
  "alternates": {
    "canonical": "https://skillbrew.ai/your-path",
    "alternate": [
      { "href": "https://skillbrew.ai/your-path", "hreflang": "en" },
      { "href": "https://skillbrew.ai/your-path-fr", "hreflang": "fr" }
    ]
  },
  "robots": { "index": true, "follow": true },
  "openGraph": {
    "title": "Share title",
    "description": "Share description",
    "image": {
      "url": "https://skillbrew.ai/your-page-slug/og-v1-20260519T103000Z.png",
      "alt": "Social share image"
    }
  }
}`;

export const CMS_PLACEHOLDER_SCHEMA_JSONLD = `{
  "documents": [
    {
      "@context": "https://schema.org",
      "@type": "WebPage",
      "name": "Your Page Title",
      "url": "https://skillbrew.ai/your-path"
    }
  ]
}`;
